import actions from './actions'
import getters from './getters'
import mutations from './mutations'

function initialState () {
  return {
    clinicians: [],
    cliniciansLoading: false,
    clinicianTeamsLoading: false,
    patientMeasures: [],
    patientMeasuresPDF: [],
    patientMeasuresPDFLoading: false,
    teams: [],
    alerts: [],
    alertsCount: 0,
    alertsCountLoading: false,
    deletingScheduleMeasure: null,
    patientSingleMeasure: {},
    patientSingleMeasureLoading: false,
    patientSingleMeasurePDF: {},
    patientSingleMeasurePDFLoading: false,
    patientSingleMeasureCompletedSessions: {},
    clinician_team: null
  }
}

// initial state
const state = initialState()

export default {
  state: {
    ...state
  },
  getters: {
    ...getters
  },
  actions: {
    ...actions
  },
  mutations: {
    ...mutations
  }
}
